<template>
  <form @submit.prevent="submit" :class="errorClass">
    <rp-password
      v-model="resource.new_password"
      placeholder="New Password"
      :error="new_passwordError"
      isRequired
      @input="touch('new_password')"/>

    <rp-password
      v-model="resource.confirm_new_password"
      placeholder="Confirm New Password"
      :error="confirm_new_passwordError"
      isRequired
      @input="touch('confirm_new_password')"/>

    <rp-button :disabled="isInvalid" type="primary">Change password</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, sameAs} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import Password from '../../../components/ui/inputs/PasswordInput'

  export default {
    name: 'ResetPassword',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-password': Password
    },

    computed: {
      ...errorMessages([
        'new_password',
        'confirm_new_password',
      ])
    },
    validations: {
      resource: {
        new_password: {required},
        confirm_new_password: {required, sameAsPassword: sameAs('new_password')}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/ForgotPasswordForm.vue